import { render, staticRenderFns } from "./LottoEventResultForm.vue?vue&type=template&id=fd0a05ca&scoped=true&"
import script from "./LottoEventResultForm.vue?vue&type=script&lang=js&"
export * from "./LottoEventResultForm.vue?vue&type=script&lang=js&"
import style0 from "./LottoEventResultForm.vue?vue&type=style&index=0&id=fd0a05ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0a05ca",
  null
  
)

export default component.exports